// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'invoice-payment.page.title': 'Invoice Payments',
    'invoice-payment.page.create.title': 'Record Payment',
    'invoice-payment.page.edit.title': 'Edit Invoice Payment',
    'invoice-payment.page.title.redo': 'Redo Payment',

    'invoice-payment.button.cancel': 'Cancel',
    'invoice-payment.button.create': 'Record Payment',
    'invoice-payment.button.new': 'Record Payment',
    'invoice-payment.button.save': 'Save Changes',
    'invoice-payment.button.refund': 'Refund Payment',
    'invoice-payment.button.payments': 'Payment History',
    'invoice-payment.button.void': 'Void Payment',
    'invoice-payment.button.rollback': 'Rollback Payment',
    'invoice-payment.button.redo': 'Redo',

    'invoice-payment.placeholder.search': 'Search invoice payments',

    'invoice-payment.link.invoice_payments': ' Return to Invoice Payments',
    'invoice-payment.link.retry': 'Click here to retry',

    'invoice-payment.message.no_payment': 'No payment has been recorded as yet.',

    'invoice-payment.label.transaction_date': 'Transaction Date',
    'invoice-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'invoice-payment.label.is_reconciled': 'Is Reconciled',
    'invoice-payment.label.payment_method': 'Payment Method',
    'invoice-payment.label.reference_code': 'Reference Code',
    'invoice-payment.label.memo': 'Memo',
    'invoice-payment.label.fx_currency_name': 'Currency',
    'invoice-payment.label.currency_amount_in_cents': 'Transaction Amount',
    'invoice-payment.label.cancelled_on': 'Cancelled On',
    'invoice-payment.label.cancellation_reason': 'Cancellation Reason',
    'invoice-payment.label.reason_for_void': 'Reason for voiding',
    'invoice-payment.label.rollback_reason': 'Reason for rollback',
    'invoice-payment.label.refund_reason': 'Reason for refund',
    'invoice-payment.label.issue_credit_memo': 'Give store credit?',
    'invoice-payment.label.status': 'Status',
    'invoice-payment.label.available_credit': 'Available Credit',
    'invoice-payment.label.use_credit': 'Use Available Credit',
    'invoice-payment.label.exchange_rate': 'Exchange Rate',
    'invoice-payment.label.issue_credit': 'Issue Credit',
    'invoice-payment.label.issue_refund': 'Issue Refund',

    'invoice-payment.modal.title.invoice_payment_void': 'Void Payment',
    'invoice-payment.modal.title.invoice_payment_refund': 'Refund Payment',
    'invoice-payment.modal.title.invoice_payment_rollback': 'Rollback Payment',
    'invoice-payment.modal.title.invoice_payment_overpayment': 'This is an overpayment',

    'invoice-payment.modal.message.cannot_rollback': 'Sorry, we are unable to rollback this payment because the overpayment credit/refund was already used.',
    'invoice-payment.modal.message.cannot_void': 'Sorry, we are unable to void this payment because the overpayment credit/refund was already used.',
    'invoice-payment.modal.message.cannot_refund': 'Sorry, we are unable to refund this payment. It may already be refunded or voided, have been paid using available credit, or already have a credit memo.',
    'invoice-payment.modal.message.already_voided': 'This payment has already been voided or reversed, so it cannot be voided again.',
    'invoice-payment.modal.message.already_rolled_back': 'This payment has already been rolled back or reversed, so it cannot be rolled back again.',
    'invoice-payment.modal.message.already_redone': 'This payment has already been reversed, so it cannot be redone again.',

    'invoice-payment.success.message.invoice_payment_created': 'Your invoice payment has been created',
    'invoice-payment.success.message.invoice_payment_updated': 'Your invoice payment has been updated',
    'invoice-payment.success.message.invoice_payment_voided': 'Your invoice payment has been voided',
    'invoice-payment.success.message.invoice_payment_refunded': 'Your invoice payment has been refunded',
    'invoice-payment.success.message.invoice_payment_rolled_back': 'Your invoice payment has been rolled back',
    'invoice-payment.success.message.invoice_payment_redone': 'Your invoice payment has been redone',

    'invoice-payment.error.message.error_loading_page': 'Sorry, there was an error loading invoice payment.| Sorry, there was an error loading invoice payments.',
    'invoice-payment.error.message.payment_not_allowed': 'This invoice has been reversed and can no longer accept a payment.',
};
